import { render, staticRenderFns } from "./CustomRadioButton.vue?vue&type=template&id=2c7386b1&scoped=true"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioButton.vue?vue&type=style&index=0&id=2c7386b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7386b1",
  null
  
)

export default component.exports